export default __webpack_public_path__ + "static/media/feature-create.7f4fb91b.png";